import React, {useContext} from 'react'
import {Modal} from '@thryvlabs/maverick'
import {ModalTitle} from '@thryvlabs/maverick'
import {useNavigate} from 'react-router-dom'
import {headerContext} from '../context/header-context'
import {useUserFeatures} from '../context/user-features-context'

const ExitOrderModal = ({cancelUrl}) => {
  const {isHeaderVisible, setIsHeaderVisible} = useContext(headerContext)
  const navigate = useNavigate()
  const {Frontend_Side_Nav: frontendSideNav} = useUserFeatures()

  function handleClick() {
    navigate(cancelUrl)

    if (frontendSideNav) {
      let elem = document.getElementById('app-container')
      elem.style.gridTemplateAreas =
        '"header header" "sidebar main-content" "sidebar footer"'
    }

    if (!isHeaderVisible) {
      setIsHeaderVisible(true)
    }
  }

  return (
    <Modal
      id="cancel-order-modal"
      btnType="primary"
      btnOutlined
      variant="default"
      btnText="Exit Order"
      btnActionText="EXIT ORDER"
      btnAction={handleClick}
      footer
      action
      footerCancel
    >
      <ModalTitle variant="subtitle" size="lg">
        Are you sure you want to exit this order?
      </ModalTitle>
    </Modal>
  )
}

export {ExitOrderModal}
